package com.narbase.letsgo.dto

import com.narbase.letsgo.models.Language
import kotlin.js.JsExport

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2021/01/10.
 */

@JsExport
interface EnumDtoName {
    val dtoName: String
    val nameAr: String? get() = null
    val nameFr: String? get() = null

    fun getNameByLanguage(language: Language) : String {
        return when (language) {
            Language.En -> dtoName
            Language.Ar -> nameAr ?: dtoName
            Language.Fr -> nameFr ?: dtoName
        }
    }
}
@JsExport
expect value class DtoName<E>(private val name: String) where E : EnumDtoName, E : Enum<E>